var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"aki-tabs",class:{'aki-tabs-scroll':_vm.scroll,
           'aki-tabs-fill':_vm.fill}},[_c('div',{staticClass:"aki-tab-layout"},[_vm._t("default"),_c('div',{staticClass:"aki-tab-line",style:({width: _vm.width, 'transform': ("translateX(" + _vm.offsetX + "px)")})})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }